import {
    getData,
    postData,
    deleteData
} from './Services'

export const getArtColoresPanel = async (artId,searchTerm, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`art_Id=${encodeURIComponent(artId || '')}`);
    }
    if (searchTerm) {
        queryParams.push(`col_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/articuloscolores", queryString);
};

export const getArtColorById = async (id) => {
    const res = await getData(`/articuloscolores/${id}`)
    return res
}

export const postArtColor = async (body) => {
    const res = await postData('/articuloscolores', body)
    return res
}

export const deleteArtColor = async (id) => {
    const res = await deleteData(`/articuloscolores/${id}`)
    return res
}